// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AllocationFactory } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/AllocationFactory';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useAllocationFactories: (
  operator: string,
  registrar: string,
) => UseQueryResult<TemplateContract<AllocationFactory>[], string> = (operator, registrar) => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();

  return useQuery({
    queryKey: ['queryAllocationFactory', offset, operator, registrar, ledgerApi],
    queryFn: async () => {
      return ledgerApi.queryAllocationFactory(offset!, operator, registrar);
    },
    enabled: !!offset,
  });
};

export default useAllocationFactories;
